import React, { useId } from "react";

export const HoneycombBackground: React.FC<{ className?: string; svgTransform?: string; flipX?: boolean }> = ({ className, svgTransform, flipX }) => {
  const uid = useId().replace(/:/g, "");
  const ids = {
    glow: `glow-${uid}`,
    honeycomb: `honeycomb-${uid}`,
    honeycomb2: `honeycomb2-${uid}`,
    radialFade: `radialFade-${uid}`,
    radialMask: `radialMask-${uid}`,
  };

  return (
    <div className={`absolute top-0 left-0 right-0 pointer-events-none h-[800px] opacity-30 ${className ?? ""}`} style={flipX ? { transform: "scaleX(-1)" } : undefined}>
      <svg
        width="100%"
        height="100%"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute inset-0"
        style={{ transform: svgTransform ?? "translate(-300px, -100px)" }}
      >
        <defs>
          <filter id={ids.glow}>
            <feGaussianBlur stdDeviation="3" result="coloredBlur" />
            <feMerge>
              <feMergeNode in="coloredBlur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>

          <pattern
            id={ids.honeycomb}
            x="0"
            y="0"
            width="100"
            height="86.6"
            patternUnits="userSpaceOnUse"
          >
            <polygon
              points="50,0 93.3,25 93.3,75 50,100 6.7,75 6.7,25"
              fill="transparent"
              stroke="#3f3f46"
              strokeWidth="1"
              opacity="0.3"
            />
            <polygon
              points="50,0 93.3,25 93.3,75 50,100 6.7,75 6.7,25"
              fill="transparent"
              stroke="#76B900"
              strokeWidth="1.5"
              filter={`url(#${ids.glow})`}
              opacity="0"
            >
              <animate attributeName="opacity" values="0;0.8;0" dur="8s" begin="0s" repeatCount="indefinite" />
            </polygon>
            <polygon
              points="50,0 93.3,25 93.3,75 50,100 6.7,75 6.7,25"
              fill="transparent"
              stroke="#76B900"
              strokeWidth="1.5"
              filter={`url(#${ids.glow})`}
              opacity="0"
            >
              <animate attributeName="opacity" values="0;0.6;0" dur="8s" begin="2s" repeatCount="indefinite" />
            </polygon>
            <polygon
              points="50,0 93.3,25 93.3,75 50,100 6.7,75 6.7,25"
              fill="transparent"
              stroke="#76B900"
              strokeWidth="1.5"
              filter={`url(#${ids.glow})`}
              opacity="0"
            >
              <animate attributeName="opacity" values="0;0.7;0" dur="8s" begin="4s" repeatCount="indefinite" />
            </polygon>
            <polygon
              points="50,0 93.3,25 93.3,75 50,100 6.7,75 6.7,25"
              fill="#76B900"
              stroke="none"
              opacity="0"
              filter={`url(#${ids.glow})`}
            >
              <animate attributeName="opacity" values="0;0.15;0" dur="8s" begin="1s" repeatCount="indefinite" />
            </polygon>
          </pattern>

          <pattern
            id={ids.honeycomb2}
            x="50"
            y="43.3"
            width="100"
            height="86.6"
            patternUnits="userSpaceOnUse"
          >
            <polygon
              points="50,0 93.3,25 93.3,75 50,100 6.7,75 6.7,25"
              fill="transparent"
              stroke="#3f3f46"
              strokeWidth="1"
              opacity="0.3"
            />
            <polygon
              points="50,0 93.3,25 93.3,75 50,100 6.7,75 6.7,25"
              fill="transparent"
              stroke="#76B900"
              strokeWidth="1.5"
              filter={`url(#${ids.glow})`}
              opacity="0"
            >
              <animate attributeName="opacity" values="0;0.7;0" dur="8s" begin="1s" repeatCount="indefinite" />
            </polygon>
            <polygon
              points="50,0 93.3,25 93.3,75 50,100 6.7,75 6.7,25"
              fill="transparent"
              stroke="#76B900"
              strokeWidth="1.5"
              filter={`url(#${ids.glow})`}
              opacity="0"
            >
              <animate attributeName="opacity" values="0;0.5;0" dur="8s" begin="3s" repeatCount="indefinite" />
            </polygon>
            <polygon
              points="50,0 93.3,25 93.3,75 50,100 6.7,75 6.7,25"
              fill="#76B900"
              stroke="none"
              opacity="0"
              filter={`url(#${ids.glow})`}
            >
              <animate attributeName="opacity" values="0;0.1;0" dur="8s" begin="2s" repeatCount="indefinite" />
            </polygon>
          </pattern>

          <radialGradient
            id={ids.radialFade}
            cx="45%"
            cy="25%"
            r="35%"
            fx="45%"
            fy="25%"
          >
            <stop offset="0%" stopColor="white" stopOpacity="1" />
            <stop offset="25%" stopColor="white" stopOpacity="0.5" />
            <stop offset="45%" stopColor="white" stopOpacity="0.1" />
            <stop offset="100%" stopColor="white" stopOpacity="0" />
          </radialGradient>

          <mask id={ids.radialMask}>
            <rect width="100%" height="100%" fill={`url(#${ids.radialFade})`} />
          </mask>
        </defs>

        <g mask={`url(#${ids.radialMask})`}>
          <rect width="100%" height="100%" fill={`url(#${ids.honeycomb})`} />
          <rect width="100%" height="100%" fill={`url(#${ids.honeycomb2})`} />
        </g>
      </svg>
    </div>
  );
};
